import { useCallback, useEffect } from 'react';
import { useAppStore } from '../store';
import { saveProject, deleteProject as fbDeleteProject, onProjects } from '../firebase';
import type { Project } from '../types';

const PROJECT_COLORS = ['#FF6B6B','#EF9F27','#378ADD','#32ADE6','#34C759','#AF52DE','#FF375F','#FF9500'];

export function useProjects(uid?: string) {
  const { projects, setProjects } = useAppStore();

  useEffect(() => {
    if (!uid) return;
    return onProjects(uid, setProjects);
  }, [uid]);

  const addProject = useCallback(async (name: string, color?: string, folderId?: string) => {
    if (!uid) return;
    const now = Date.now();
    const project: Project = {
      id: crypto.randomUUID(),
      uid,
      name,
      color: color ?? PROJECT_COLORS[projects.length % PROJECT_COLORS.length],
      folderId,
      createdAt: now,
      updatedAt: now,
      archived: false,
    };
    await saveProject(uid, project);
    return project;
  }, [uid, projects.length]);

  const updateProject = useCallback(async (id: string, changes: Partial<Project>) => {
    if (!uid) return;
    const project = projects.find(p => p.id === id);
    if (!project) return;
    await saveProject(uid, { ...project, ...changes, updatedAt: Date.now() });
  }, [uid, projects]);

  const deleteProject = useCallback(async (id: string) => {
    if (!uid) return;
    await fbDeleteProject(uid, id);
  }, [uid]);

  return { projects, addProject, updateProject, deleteProject };
}
